import { render, staticRenderFns } from "./ButtonStartVoice.vue?vue&type=template&id=02c6b03b&scoped=true&"
import script from "./ButtonStartVoice.vue?vue&type=script&lang=js&"
export * from "./ButtonStartVoice.vue?vue&type=script&lang=js&"
import style0 from "./ButtonStartVoice.vue?vue&type=style&index=0&id=02c6b03b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c6b03b",
  null
  
)

export default component.exports